import styled from 'styled-components'

export const ButtonContainer = styled.button`
    border:none;
    padding: 0;
    
    [ant-click-animating-without-extra-node]:after {
    -webkit-animation: none !important;
    -moz-animation: none !important;
    -o-animation: none !important;
    -ms-animation: none !important;
    animation: none !important;
    }

    a.ant-btn > span {
        line-height: 48px;
    }
`